// src/components/UserManagementPopUp.js

import React, { useEffect } from "react";
import "./UserManagementPopUp.css";

const UserManagementPopUp = ({
  show,
  handleClose,
  formData,
  handleInputChange,
  handleSubmit,
  formErrors,
  isEditMode,
  roleOptions,
}) => {
  const {
    email = "",
    password = "",
    firstName = "",
    lastName = "",
    username = "",
    role = "student",
  } = formData || {};

  useEffect(() => {
    console.log("UserManagementPopUp rendered with formData:", formData);
  }, [formData]);

  const isCreatingNewUser = formData === null;
  const isEmailDisabled = isEditMode && !isCreatingNewUser;

  if (!show) {
    return null;
  }

  return (
    <div className="user-management-modal-overlay" onClick={handleClose}>
      <div
        className="user-management-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="user-management-close" onClick={handleClose}>
          &times;
        </span>
        <div className="user-management-modal-content">
          <form
            onSubmit={handleSubmit}
            autoComplete="off"
            className="user-form"
          >
            {/* Form fields */}
            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={handleInputChange}
                required
                disabled={isEmailDisabled}
                autoComplete="new-email"
                className="user-form-input"
              />
              {formErrors?.email && (
                <span className="error">{formErrors.email}</span>
              )}
            </div>
            <div className="form-group">
              <label>First Name:</label>
              <input
                type="text"
                name="firstName"
                value={firstName}
                onChange={handleInputChange}
                required
                autoComplete="new-first-name"
                className="user-form-input"
              />
              {formErrors?.firstName && (
                <span className="error">{formErrors.firstName}</span>
              )}
            </div>
            <div className="form-group">
              <label>Last Name:</label>
              <input
                type="text"
                name="lastName"
                value={lastName}
                onChange={handleInputChange}
                required
                autoComplete="new-last-name"
                className="user-form-input"
              />
              {formErrors?.lastName && (
                <span className="error">{formErrors.lastName}</span>
              )}
            </div>
            <div className="form-group">
              <label>Username:</label>
              <input
                type="text"
                name="username"
                value={username}
                onChange={handleInputChange}
                autoComplete="username"
                className={`user-form-input ${
                  formErrors?.username ? "error-input" : ""
                }`}
              />
              {formErrors?.username && (
                <span className="error">{formErrors.username}</span>
              )}
            </div>
            <div className="form-group">
              <label>Password:</label>
              <input
                type="password"
                name="password"
                placeholder={
                  isEditMode
                    ? "Enter a new password to change"
                    : "Enter password"
                }
                value={password}
                onChange={handleInputChange}
                required={!isEditMode}
                autoComplete="new-password"
                className="user-form-input"
              />
              {formErrors?.password && (
                <span className="error">{formErrors.password}</span>
              )}
            </div>
            {!isEditMode && (
              <div className="form-group">
                <label>Role:</label>
                <select
                  name="role"
                  value={role}
                  onChange={handleInputChange}
                  required
                  autoComplete="off"
                >
                  {roleOptions.map((option) => (
                    <option key={option} value={option}>
                      {option.charAt(0).toUpperCase() + option.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {formErrors?.general && (
              <div className="form-group">
                <span className="error">{formErrors.general}</span>
              </div>
            )}
            <button type="submit" className="submit-button">
              {isEditMode ? "Update User" : "Create User"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserManagementPopUp;
